// ============================================================
// STARDATE SCENT QUIZ — MAIN ENGINE
// ============================================================

(function () {
  'use strict';

  const CONFIG = window.QUIZ_CONFIG;
  if (!CONFIG) { console.error('Stardate Quiz: quiz-config.js not loaded.'); return; }

  // ----------------------------------------------------------
  // STATE
  // ----------------------------------------------------------
  const state = {
    currentScreen: 0,
    answers: {
      whoFor:        null,
      occasion:      null,
      personality:   null,
      vibe:          null,
      scentFamily:   null,
      birthday:      { day: null, month: null, year: null },
      name:          '',
      email:         '',
      purchaserName: ''
    },
    results: {
      zodiac:            null,
      top3Fragrances:    [],
      selectedFragrance: null,
      dateTag:           null
    }
  };

  const SCREENS = [
    'hero', 'who-for', 'occasion', 'personality', 'vibe',
    'scent-family', 'birthday', 'name', 'email',
    'loading', 'fragrance-results', 'product-results'
  ];

  // ----------------------------------------------------------
  // UTILITIES
  // ----------------------------------------------------------
  function qs(sel, ctx)  { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return (ctx || document).querySelectorAll(sel); }

  function assetUrl(filename) {
    const base = window.STARDATE_ASSET_BASE || '';
    return base ? base + filename : filename;
  }

  // ----------------------------------------------------------
  // ZODIAC CALCULATOR
  // ----------------------------------------------------------
  function getZodiac(day, month) {
    const d = parseInt(day, 10);
    const m = parseInt(month, 10);
    for (const z of CONFIG.zodiacDates) {
      const s = z.start, e = z.end;
      if (s.m > e.m) {
        if ((m === s.m && d >= s.d) || (m === e.m && d <= e.d)) return z.sign;
      } else {
        if ((m === s.m && d >= s.d) || (m === e.m && d <= e.d) || (m > s.m && m < e.m)) return z.sign;
      }
    }
    return 'Capricorn';
  }
  function showZodiacPanel(day, month) {
  var panel = qs('#quiz-zodiac-panel');
  if (!panel) return;
  if (!day || !month) {
    panel.style.display = 'none';
    return;
  }
  var sign = getZodiac(day, month);
  var meta = CONFIG.zodiacMeta ? CONFIG.zodiacMeta[sign] : null;
  if (!meta) {
    panel.style.display = 'none';
    return;
  }
  qs('#quiz-zodiac-name').textContent = sign;
  qs('#quiz-zodiac-dates').textContent = meta.dates;
  qs('#quiz-zodiac-element').textContent = meta.ruler + '. ' + meta.element + ' Sign.';
  qs('#quiz-zodiac-traits').textContent = meta.traits;
  panel.style.display = 'block';
}

  // ----------------------------------------------------------
  // DATE TAG  e.g. day=22, month=9 → "Sep-22"
  // ----------------------------------------------------------
  function buildDateTag(day, month) {
    const m = CONFIG.monthTagMap[parseInt(month, 10)];
    const d = parseInt(day, 10);
    return m.toLowerCase() + '-' + (d < 10 ? '0' + d : d);
  }

  // ----------------------------------------------------------
  // SCORING ENGINE
  // ----------------------------------------------------------
  function computeScores() {
    const signs = Object.keys(CONFIG.fragrances);
    const scores = {};
    signs.forEach(s => scores[s] = 0);

    const add = (table, answer) => {
      if (!answer) return;
      const w = table[answer];
      if (w) signs.forEach(s => scores[s] += (w[s] || 0));
    };

    add(CONFIG.scoring.personality, state.answers.personality);
    add(CONFIG.scoring.vibe,        state.answers.vibe);
    add(CONFIG.scoring.scentFamily, state.answers.scentFamily);
    add(CONFIG.scoring.occasion, state.answers.occasion);

    if (state.results.zodiac) {
      scores[state.results.zodiac] = (scores[state.results.zodiac] || 0) + CONFIG.scoring.zodiacBonus;
    }

    return signs
      .map(s => ({ sign: s, score: scores[s], fragrance: CONFIG.fragrances[s] }))
      .sort((a, b) => b.score - a.score || a.sign.localeCompare(b.sign))
      .slice(0, 3);
  }

  // ----------------------------------------------------------
  // SCREEN TRANSITIONS
  // ----------------------------------------------------------
function showScreen(name) {
  qsa('.quiz-screen').forEach(el => {
    el.classList.remove('quiz-screen--active', 'quiz-screen--enter');
  });
  const target = qs('.quiz-screen[data-screen="' + name + '"]');
  if (!target) return;
  target.classList.add('quiz-screen--active');

  // Force container height immediately — before rAF
  const quiz = qs('#stardate-quiz');
  if (quiz) {
    // Temporarily make visible to measure
    target.style.visibility = 'hidden'; // MOBILE GALLERY
    target.style.opacity = '1';
    const h = Math.max(target.scrollHeight, window.innerHeight);
    target.style.visibility = '';
    target.style.opacity = '';
    quiz.style.minHeight = h + 'px';
    quiz.style.height = h + 'px';
  }

  requestAnimationFrame(() => requestAnimationFrame(() =>
    target.classList.add('quiz-screen--enter')
  ));
  state.currentScreen = SCREENS.indexOf(name);
  updateProgress(name);
  document.documentElement.scrollTop = 0;
  document.body.scrollTop = 0;

  // Track screen view in GA4
  if (typeof gtag === 'function') {
    gtag('event', 'quiz_screen_view', {
      'quiz_screen': name,
      'quiz_step': SCREENS.indexOf(name)
    });
  }
}

function updateProgress(screenName) {
  var steps = ['who-for','occasion','personality','vibe','scent-family','birthday','name','email'];
  var idx = steps.indexOf(screenName);
  var container = qs('#quiz-progress');
  if (!container) return;
 
  if (idx === -1) {
    // Not a question screen — hide
    container.innerHTML = '';
    container.style.cssText = 'display:none !important;';
    return;
  }
 
  var step = idx + 1;
  var total = steps.length;
  var isDesktop = window.innerWidth >= 990;
 
  // Build segments HTML
  var segsHtml = '';
  for (var i = 0; i < total; i++) {
    var bg = i < step ? '#1a1a1a' : '#CCCAC4';
    segsHtml += '<span style="flex:1;height:2px;background:' + bg + ';display:block;transition:background .4s ease;"></span>';
  }
 
  var html;
 
  if (isDesktop) {
    // Desktop: STARDATE left, centred bar flanked by step numbers, border bottom
    html =
      '<div style="display:flex;align-items:center;justify-content:space-between;padding:18px 56px;background:#fffcf5;border-bottom:1px solid rgba(26,26,26,0.18);">' +
        '<a href="https://www.stardateco.com.au/" style="display:inline-flex;align-items:center;line-height:0;pointer-events:all;cursor:pointer;"><img src="https://cdn.shopify.com/s/files/1/0599/4830/2495/files/STAR_Logo_Lockup_-_Horizontal_Green_1.svg?v=1779364652" alt="Stardate" style="height:28px;width:auto;display:block;"></a>' +
        '<div style="display:flex;align-items:center;gap:14px;flex:1;max-width:520px;margin:0 40px;">' +
          '<span style="font-family:\'JetBrains Mono\',ui-monospace,monospace;font-size:10px;letter-spacing:1.5px;color:#888880;">' + String(step).padStart(2, '0') + '</span>' +
          '<div style="flex:1;display:flex;gap:4px;">' + segsHtml + '</div>' +
          '<span style="font-family:\'JetBrains Mono\',ui-monospace,monospace;font-size:10px;letter-spacing:1.5px;color:#888880;">' + String(total).padStart(2, '0') + '</span>' +
        '</div>' +
        '<a href="/" aria-label="Close quiz and return home" style="display:inline-flex;align-items:center;justify-content:center;width:32px;height:32px;color:#888880;text-decoration:none;font-size:16px;line-height:1;cursor:pointer;pointer-events:all;">✕</a>' +
      '</div>';
  } else {
    // Mobile: brand + sep left, step counter right, bar below
    html =
      '<div style="background:#fffcf5;border-bottom:1px solid rgba(26,26,26,0.18);">' +
        '<div style="display:flex;align-items:center;justify-content:space-between;padding:14px 24px 6px;">' +
          '<div style="display:flex;align-items:center;">' +
            '<a href="https://www.stardateco.com.au/" style="display:inline-flex;align-items:center;line-height:0;pointer-events:all;cursor:pointer;"><img src="https://cdn.shopify.com/s/files/1/0599/4830/2495/files/STAR_Logo_Lockup_-_Horizontal_Green_1.svg?v=1779364652" alt="Stardate" style="height:22px;width:auto;display:block;"></a>' +
'<span style="font-family:\'JetBrains Mono\',ui-monospace,monospace;font-size:9px;letter-spacing:1.5px;text-transform:uppercase;color:#888880;margin-left:10px;">· Scent quiz</span>' +
          '</div>' +
          '<div style="display:flex;align-items:center;gap:12px;">' +
            '<span style="font-family:\'JetBrains Mono\',ui-monospace,monospace;font-size:9px;letter-spacing:1.5px;color:#888880;">' + String(step).padStart(2, '0') + ' / ' + String(total).padStart(2, '0') + '</span>' +
            '<a href="/" aria-label="Close quiz and return home" style="display:inline-flex;align-items:center;justify-content:center;width:28px;height:28px;margin-right:-6px;color:#888880;text-decoration:none;font-size:13px;line-height:1;cursor:pointer;pointer-events:all;">✕</a>' +
          '</div>' +
        '</div>' +
        '<div style="display:flex;gap:4px;padding:0 24px 12px;">' + segsHtml + '</div>' +
      '</div>';
  }
 
  container.style.cssText = 'display:block !important;width:100% !important;position:relative !important;z-index:10 !important;background:#fffcf5 !important;padding:0 !important;margin:0 !important;';
  container.innerHTML = html;
}
 
// ▲▲▲ End of replacement ▲▲▲

  // ----------------------------------------------------------
  // CARD GRID — auto-advance on selection
  // ----------------------------------------------------------
  function initCardGrid(screen, key, next) {
    qsa('.quiz-card', screen).forEach(card => {
      card.addEventListener('click', () => {
        qsa('.quiz-card', screen).forEach(c => c.classList.remove('quiz-card--selected'));
        card.classList.add('quiz-card--selected');
        state.answers[key] = card.dataset.value;
        setTimeout(() => next(card.dataset.value), 280);
      });
      card.setAttribute('tabindex', '0');
      card.addEventListener('keydown', e => {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); card.click(); }
      });
    });
  }
// ----------------------------------------------------------
  // MOBILE GALLERY
  // ----------------------------------------------------------
  function initMobileGallery(top3) {
    if (window.innerWidth > 768) return;

    const prevBtn = qs('#gallery-prev');
    const nextBtn = qs('#gallery-next');
    const imgEl   = qs('#gallery-img');
    const caption = qs('#gallery-caption');
    const label    = qs('#gallery-label');
    const sublabel = qs('#gallery-sublabel');
    const fragranceGallery = qs('.fragrance-gallery');
const dots = fragranceGallery ? qsa('.fragrance-gallery__dot', fragranceGallery) : [];

    if (!prevBtn || !nextBtn || !imgEl) {
      console.warn('Stardate: mobile gallery elements not found');
      return;
    }

    const labels = [
      CONFIG.copy.results.bestMatch,
      CONFIG.copy.results.secondFave,
      CONFIG.copy.results.thirdLoveFragrance
    ];

    let current = 0;

    function goTo(idx) {
      if (idx < 0 || idx > 2) return;
      current = idx;

      var item = top3[idx];
      var f    = item.fragrance;

      // Set image — try metaobject first, fall back to config
      var imgSrc = '';
      var metaHandle = (CONFIG.fragranceHandles || {})[item.sign];
      var metaFrag = metaHandle ? (window.STARDATE_FRAGRANCES || {})[metaHandle] : null;
      if (metaFrag && metaFrag.image) {
        imgSrc = metaFrag.image;
      } else {
        var fn = (CONFIG.fragranceImages || {})[f.name] || '';
        if (fn) {
          var ab = window.STARDATE_ASSET_BASE || '';
          imgSrc = ab ? ab + fn : fn;
        }
      }
      if (imgSrc) {
  imgEl.src = imgSrc.indexOf('//') === 0 ? 'https:' + imgSrc : imgSrc;
}
      console.log('MOBILE IMG:', idx, item.sign, imgSrc);
      imgEl.alt = f.name;

      caption.textContent = f.name.toUpperCase();
      label.textContent = '';
      if (sublabel) sublabel.textContent = '';

      // Add badge to top of polaroid
      var polaroid = qs('.fragrance-gallery__polaroid');
      if (polaroid) {
        var existingBadge = polaroid.querySelector('.frag-mobile-badge');
        if (existingBadge) existingBadge.remove();
        var badge = document.createElement('span');
        badge.className = 'frag-mobile-badge';
        badge.style.cssText = 'position:absolute; top:-12px; left:50%; transform:translateX(-50%); background:#B4AA4A; color:#003835; font-family:\'Bebas Neue\',sans-serif; font-size:10px; letter-spacing:2px; text-transform:uppercase; padding:4px 10px; white-space:nowrap; z-index:5;';
        badge.textContent = '★ ' + labels[idx];
        polaroid.style.position = 'relative';
        polaroid.insertBefore(badge, polaroid.firstChild);
      }

      dots.forEach(function(d, i) {
        d.classList.toggle('fragrance-gallery__dot--active', i === idx);
      });

      prevBtn.disabled = (idx === 0);
      nextBtn.disabled = (idx === 2);

      state.results.selectedFragrance = item;
      updateFragranceNotes(f);

      // Klaviyo: track fragrance selection on mobile gallery navigation
      // Only fires on user-initiated navigation (not the initial goTo(0) call)
      // Klaviyo: track fragrance selection on mobile gallery navigation
      // Helper functions defined outside try block to avoid parse failures
      var getMobileFragImage = function(fragIdx) {
        if (!top3[fragIdx]) return '';
        var h = (CONFIG.fragranceHandles || {})[top3[fragIdx].sign];
        var m = h && window.STARDATE_FRAGRANCES ? window.STARDATE_FRAGRANCES[h] : null;
        return m && m.image ? m.image : '';
      };

      var getMobileFragLifestyleImage = function(fragIdx) {
        if (!top3[fragIdx]) return '';
        var h = (CONFIG.fragranceHandles || {})[top3[fragIdx].sign];
        var m = h && window.STARDATE_FRAGRANCES ? window.STARDATE_FRAGRANCES[h] : null;
        return m && m.imageLifestyle ? m.imageLifestyle : '';
      };

      try {
        if ((idx !== 0 || current !== 0) && state.answers.email && window._learnq) {
          var mSelHandle = (CONFIG.fragranceHandles || {})[item.sign];
          var mSelMeta = mSelHandle && window.STARDATE_FRAGRANCES
            ? window.STARDATE_FRAGRANCES[mSelHandle] : null;
          var mSelNotes = mSelMeta
            ? [mSelMeta.topNotes, mSelMeta.heartNotes, mSelMeta.baseNotes]
                .filter(Boolean).join(' · ')
            : '';

          window._learnq.push(['track', 'Scent Quiz Fragrance Selected', {
            'Quiz Session ID': state.results.quizSessionId || '',
            'Purchaser Name': state.answers.purchaserName || '',

            // Selected fragrance
            'Selected Fragrance': f.name,
            'Selected Fragrance Sign': item.sign,
            'Selected Fragrance Image URL': mSelMeta && mSelMeta.image ? mSelMeta.image : '',
            'Selected Fragrance Lifestyle Image URL': mSelMeta && mSelMeta.imageLifestyle ? mSelMeta.imageLifestyle : '',
            'Selected Fragrance Description': mSelMeta && mSelMeta.description ? mSelMeta.description : '',
            'Selected Fragrance Primary Scent Profile': mSelMeta && mSelMeta.primaryScentProfile ? mSelMeta.primaryScentProfile : '',
            'Selected Fragrance Notes': mSelNotes,

            // All three matches with images
            'Top Fragrance': top3[0] ? top3[0].fragrance.name : '',
            'Top Fragrance Image URL': getMobileFragImage(0),
            'Top Fragrance Lifestyle Image URL': getMobileFragLifestyleImage(0),
            'Second Fragrance': top3[1] ? top3[1].fragrance.name : '',
            'Second Fragrance Image URL': getMobileFragImage(1),
            'Second Fragrance Lifestyle Image URL': getMobileFragLifestyleImage(1),
            'Third Fragrance': top3[2] ? top3[2].fragrance.name : '',
            'Third Fragrance Image URL': getMobileFragImage(2),
            'Third Fragrance Lifestyle Image URL': getMobileFragLifestyleImage(2),

            // Recipient context
            'Recipient Name': state.answers.name || '',
            'Recipient Birthday Day': state.answers.birthday.day || '',
            'Recipient Birthday Month': state.answers.birthday.month || '',
            'Zodiac Sign': state.results.zodiac || '',
            'Occasion': state.answers.occasion || ''
          }]);
        }
      } catch(e) {
        console.error('Klaviyo mobile fragrance error:', e);
      }
    }

    prevBtn.onclick = function() { goTo(current - 1); };
nextBtn.onclick = function() { goTo(current + 1); };

    goTo(0);
  }

  // ----------------------------------------------------------
  // BUILD FRAGRANCE RESULTS
  // ----------------------------------------------------------
  function updateFragranceNotes(fragrance) {
  var panel = qs('#fragrance-notes-panel');
  var desc  = qs('#fragrance-notes-description');
  var top   = qs('#fragrance-notes-top');
  var heart = qs('#fragrance-notes-heart');
  var base  = qs('#fragrance-notes-base');
  if (!panel) return;

  var metaData = null;
  var handles = CONFIG.fragranceHandles || {};
  var fragrances = window.STARDATE_FRAGRANCES || {};

  for (var sign in handles) {
    if (CONFIG.fragrances[sign] && CONFIG.fragrances[sign].name === fragrance.name) {
      metaData = fragrances[handles[sign]];
      break;
    }
  }

  if (metaData) {
    desc.textContent  = metaData.description || '';
    top.textContent   = metaData.topNotes || '';
    heart.textContent = metaData.heartNotes || '';
    base.textContent  = metaData.baseNotes || '';
  } else {
    desc.textContent  = fragrance.description  || '';
    top.textContent   = fragrance.topNotes     || '';
    heart.textContent = fragrance.heartNotes   || '';
    base.textContent  = fragrance.baseNotes    || '';
  }
}

  function buildFragranceResults() {
    const top3  = state.results.top3Fragrances;
    const rawName = state.answers.name;
    const name = rawName ? rawName + "'s" : 'their';
    const cfg   = CONFIG.copy.results;

    qs('#fragrance-results-heading').textContent = cfg.fragranceHeading.replace('{{name}}', name);
    qs('#fragrance-results-subtext').textContent = cfg.fragranceSubtext.replace('{{name}}', name);

    // Podium order: 2nd left, 1st centre, 3rd right
    const order  = [top3[1], top3[0], top3[2]];
    const labels = [cfg.secondFave, cfg.bestMatch, cfg.thirdLoveFragrance];
    const slots  = qsa('.fragrance-card-slot');

    slots.forEach((slot, i) => {
      if (!order[i]) return;
      const f      = order[i].fragrance;
      var metaHandle = CONFIG.fragranceHandles ? CONFIG.fragranceHandles[order[i].sign] : null;
var metaFrag = metaHandle && window.STARDATE_FRAGRANCES ? window.STARDATE_FRAGRANCES[metaHandle] : null;
var imgUrl = (metaFrag && metaFrag.image) ? metaFrag.image : assetUrl(CONFIG.fragranceImages[f.name] || '');
      const isMain = (i === 1);

      slot.dataset.sign      = order[i].sign;
      slot.dataset.fragrance = f.name;

      slot.innerHTML =
        '<div class="fragrance-polaroid' + (isMain ? ' fragrance-polaroid--main' : '') + '">' +
          '<div class="fragrance-polaroid__img-wrap">' +
            '<img src="' + imgUrl + '" alt="' + f.name + '" class="fragrance-polaroid__img" loading="lazy">' +
          '</div>' +
          '<div class="fragrance-polaroid__caption">' + f.name.toUpperCase() + '</div>' +
        '</div>' +
        '<span style="position:absolute; top:-12px; left:' + (i===1 ? '50%; transform:translateX(-50%)' : '12px; transform:none') + '; background:#B4AA4A; color:#003835; font-family:\'Bebas Neue\',sans-serif; font-size:10px; letter-spacing:2px; text-transform:uppercase; padding:4px 10px; white-space:nowrap; z-index:5;">★ ' + labels[i] + '</span>';

      slot.addEventListener('click', () => {
        qsa('.fragrance-card-slot').forEach(s => s.classList.remove('fragrance-card-slot--selected'));
        slot.classList.add('fragrance-card-slot--selected');
        state.results.selectedFragrance = order[i];
        updateFragranceNotes(order[i].fragrance);

        // Klaviyo: track fragrance selection for Flow 7 Track B branching
        if (state.answers.email && window._learnq) {
          var selHandle = (CONFIG.fragranceHandles || {})[order[i].sign];
          var selMeta = selHandle && window.STARDATE_FRAGRANCES
            ? window.STARDATE_FRAGRANCES[selHandle] : null;
          var selNotes = selMeta
            ? [selMeta.topNotes, selMeta.heartNotes, selMeta.baseNotes]
                .filter(Boolean).join(' · ')
            : '';

          var getTopFragImage = function(idx) {
            var top3 = state.results.top3Fragrances;
            if (!top3[idx]) return '';
            var h = (CONFIG.fragranceHandles || {})[top3[idx].sign];
            var m = h && window.STARDATE_FRAGRANCES ? window.STARDATE_FRAGRANCES[h] : null;
            return m && m.image ? m.image : '';
          };

          var getTopFragLifestyleImage = function(idx) {
            var top3 = state.results.top3Fragrances;
            if (!top3[idx]) return '';
            var h = (CONFIG.fragranceHandles || {})[top3[idx].sign];
            var m = h && window.STARDATE_FRAGRANCES ? window.STARDATE_FRAGRANCES[h] : null;
            return m && m.imageLifestyle ? m.imageLifestyle : '';
          };

          window._learnq.push(['track', 'Scent Quiz Fragrance Selected', {
            'Quiz Session ID': state.results.quizSessionId || '',
            'Purchaser Name': state.answers.purchaserName || '',

            // Selected fragrance
            'Selected Fragrance': order[i].fragrance.name,
            'Selected Fragrance Sign': order[i].sign,
            'Selected Fragrance Image URL': selMeta && selMeta.image ? selMeta.image : '',
            'Selected Fragrance Lifestyle Image URL': selMeta && selMeta.imageLifestyle ? selMeta.imageLifestyle : '',
            'Selected Fragrance Description': selMeta && selMeta.description ? selMeta.description : '',
            'Selected Fragrance Primary Scent Profile': selMeta && selMeta.primaryScentProfile ? selMeta.primaryScentProfile : '',
            'Selected Fragrance Notes': selNotes,

            // All three matches with images
            'Top Fragrance': state.results.top3Fragrances[0] ? state.results.top3Fragrances[0].fragrance.name : '',
            'Top Fragrance Image URL': getTopFragImage(0),
            'Top Fragrance Lifestyle Image URL': getTopFragLifestyleImage(0),
            'Second Fragrance': state.results.top3Fragrances[1] ? state.results.top3Fragrances[1].fragrance.name : '',
            'Second Fragrance Image URL': getTopFragImage(1),
            'Second Fragrance Lifestyle Image URL': getTopFragLifestyleImage(1),
            'Third Fragrance': state.results.top3Fragrances[2] ? state.results.top3Fragrances[2].fragrance.name : '',
            'Third Fragrance Image URL': getTopFragImage(2),
            'Third Fragrance Lifestyle Image URL': getTopFragLifestyleImage(2),

            // Recipient context
            'Recipient Name': state.answers.name || '',
            'Recipient Birthday Day': state.answers.birthday.day || '',
            'Recipient Birthday Month': state.answers.birthday.month || '',
            'Zodiac Sign': state.results.zodiac || '',
            'Occasion': state.answers.occasion || ''
          }]);
        }
      });
      slot.setAttribute('tabindex', '0');
      slot.addEventListener('keydown', e => { if (e.key === 'Enter') slot.click(); });
    });

    // Pre-select best match (centre slot)
    slots[1]?.classList.add('fragrance-card-slot--selected');
    state.results.selectedFragrance = top3[0];
    updateFragranceNotes(top3[0].fragrance);

    setTimeout(() => initMobileGallery(top3), 1500);
  }

  // ----------------------------------------------------------
  // MOBILE PRODUCT GALLERY
  // ----------------------------------------------------------
  function initProductGallery(podiumOrder, productData, recipName, bdayStr, zodiac, fragrance) {
    if (window.innerWidth > 768) return;

    var gallery = qs('#product-gallery');
    if (!gallery) return;

    // Reorder: best match first on mobile
    var mobileOrder = [podiumOrder[1], podiumOrder[0], podiumOrder[2]];
    var mobileData  = [productData[1], productData[0], productData[2]];

    var html = '<div style="display:flex; flex-direction:column; gap:12px; width:100%; padding:0 5%;">';

    mobileOrder.forEach(function(p, idx) {
      var data = mobileData[idx];
      var imgUrl    = data && data.image ? data.image : '';
      var title     = data && data.title ? data.title : p.type;
      var price     = data && data.price ? '$' + (parseInt(data.price) / 100).toFixed(2) : '';
      var variantId = data && data.variantId ? data.variantId : '';
      var isMain    = p.isMain;
      var sub       = p.sub || '';

      var mobileProductLink = data && data.url ? data.url : '#';

      html +=
        '<div style="display:flex; gap:12px; padding:12px; border:1px solid ' + (isMain ? '#1a1a1a' : 'rgba(0,0,0,0.12)') + '; background:rgba(0,0,0,0.02); position:relative;">' +
          (isMain ? '<span style="position:absolute; top:-10px; left:12px; background:#B4AA4A; color:#fff; font-family:\'Bebas Neue\',sans-serif; font-size:9px; letter-spacing:2px; text-transform:uppercase; padding:3px 8px;">★ Highly Recommended</span>' : '') +
          '<div style="width:100px; height:100px; flex-shrink:0; overflow:hidden; background:' + (imgUrl ? 'transparent' : '#E8E0D4') + ';">' +
            (imgUrl
              ? '<a href="' + mobileProductLink + '" target="_blank" rel="noopener noreferrer" style="display:block;width:100%;height:100%;line-height:0;cursor:pointer;" aria-label="View ' + title + ' product page"><img src="' + imgUrl + '" alt="' + title + '" style="width:100%; height:100%; object-fit:cover; display:block;"></a>'
              : '') +
          '</div>' +
          '<div style="flex:1; display:flex; flex-direction:column; justify-content:space-between;">' +
            '<div>' +
              '<div style="font-family:\'Astralaga\',\'Antic Didone\',Georgia,serif; font-size:' + (isMain ? '20px' : '18px') + '; font-weight:400; color:#1a1a1a; line-height:1.1;"><a href="' + mobileProductLink + '" target="_blank" rel="noopener noreferrer" style="color:inherit;text-decoration:none;cursor:pointer;">' + title + '</a></div>' +
              '<div style="font-family:\'Antic Didone\',Georgia,serif; font-size:11px; color:#888880; margin-top:3px;">' + sub + '</div>' +
            '</div>' +
            '<div style="display:flex; justify-content:space-between; align-items:center; margin-top:8px;">' +
              '<span style="font-family:\'Astralaga\',\'Antic Didone\',Georgia,serif; font-size:20px; font-weight:400; color:#1a1a1a;">' + price + '</span>' +
              '<button class="product-card-new__atc" style="padding:9px 16px; font-family:\'Bebas Neue\',sans-serif; font-size:11px; letter-spacing:2px; cursor:pointer; ' +
                (isMain ? 'background:#1a1a1a; color:#fff; border:none;' : 'background:transparent !important; color:#1a1a1a !important; border:1px solid #1a1a1a !important;') + '"' +
                ' data-variant="' + variantId + '"' +
                ' data-recipient="' + recipName + '"' +
                ' data-birthday="' + bdayStr + '"' +
                ' data-zodiac="' + zodiac + '"' +
                ' data-fragrance="' + fragrance + '">' +
                'ADD →' +
              '</button>' +
            '</div>' +
          '</div>' +
        '</div>';
    });

    html += '</div>';
    gallery.innerHTML = html;

    // Bind ATC buttons
    gallery.querySelectorAll('.product-card-new__atc').forEach(function(btn) {
      btn.addEventListener('click', function() { handleProductAtc(btn); });
    });
  }

  // ----------------------------------------------------------
  // BUILD PRODUCT RESULTS
  // ----------------------------------------------------------
  async function buildProductResults() {
    const sel       = state.results.selectedFragrance;
    const recipName = state.answers.name || '';
    const name      = recipName ? recipName + "'s" : 'their';
    const cfg       = CONFIG.copy.results;
    const zodiac    = state.results.zodiac;
    const fragrance = sel ? sel.fragrance.name : '';
    const dateTag   = state.results.dateTag;
    const bDay      = state.answers.birthday.day;
    const bMonth    = state.answers.birthday.month;
    const bYear     = state.answers.birthday.year;
    const bdayStr   = bDay
      ? bDay + ' ' + CONFIG.monthTagMap[parseInt(bMonth, 10)] + (bYear ? ' ' + bYear : '')
      : '';

    // Header
    qs('#product-results-heading').textContent =
      cfg.productHeading.replace('{{name}}', name);
    qs('#product-results-subtext').textContent =
      cfg.productSubtext.replace('{{name}}', recipName || 'them');
      var fragranceTitle = window.STARDATE_FRAGRANCES && window.STARDATE_FRAGRANCES[fragrance]
  ? window.STARDATE_FRAGRANCES[fragrance].title
  : fragrance;
qs('#product-results-fragrance').textContent = fragranceTitle;

    // Personalisation panel
    qs('#product-personal-heading').textContent =
      'Gifts designed to feel personal and meaningful for ' + (recipName || 'them');
    qs('#product-personal-name').textContent    = recipName;
    const madeForEl = qs('.product-personalisation__made-for');
    if (madeForEl) madeForEl.style.display = recipName ? '' : 'none';
    qs('#product-personal-date').textContent    = bdayStr;
    qs('#product-personal-zodiac').textContent  = zodiac || '';
    qs('#product-personal-fragrance').textContent = fragrance;

    // Proof description
    const proofDesc = sel
      ? 'As a ' + zodiac + ', ' + (recipName || 'they') + ' naturally embodies the traits of being ' +
        sel.fragrance.traits + '. ' + sel.fragrance.name + ' complements that energy perfectly.'
      : '';
    qs('#product-proof-desc').textContent = proofDesc;

    // Dynamic testimonial based on best match product type
    const testimonialData = CONFIG.testimonials[CONFIG.productTypeTags.birthdayCandle] || {};
    const testimonialEl   = qs('#product-proof-testimonial');
    if (testimonialEl && testimonialData.quote) {
      testimonialEl.innerHTML =
        '"' + testimonialData.quote + '"' +
        (testimonialData.author
          ? '<span class="product-proof__testimonial-author"> — ' + testimonialData.author + '</span>'
          : '');
    }

    // Feature icons
    const icons = CONFIG.featureIcons || {};
    const iconHtml = (url, label) =>
      '<span class="product-proof__feature">' +
        (url
          ? '<img src="' + url + '" alt="" class="product-proof__feature-icon">'
          : '<span class="product-proof__feature-icon-placeholder"></span>') +
        label +
      '</span>';

    const featuresEl = qs('#product-proof-features');
    if (featuresEl) {
      featuresEl.innerHTML =
        iconHtml(icons.handPoured,   'Hand-poured in Australia') +
        iconHtml(icons.personalised, 'Personalised just for them') +
        iconHtml(icons.fastDispatch, 'Fast dispatch');
    }

    // Define 3 products
    const products = [
      {
        type:     CONFIG.productTypeTags.birthdayCandle,
        label:    cfg.bestMatch,
        position: 'top',
        isMain:   true,
        sub:      'Personalised with ' + (recipName || 'their') + "'s birthday, zodiac and astrological reading."
      },
      {
        type:     CONFIG.productTypeTags.birthdayDiffuser,
        label:    cfg.secondFave,
        position: 'left',
        isMain:   false,
        sub:      'Same zodiac reading, different format.'
      },
      {
        type:     CONFIG.productTypeTags.giftCard,
        label:    cfg.thirdLove,
        position: 'right',
        isMain:   false,
        sub:      'Let them choose their own Stardate experience.'
      }
    ];

    // Fetch all 3 products in parallel
    const podium  = qs('#product-podium');
    podium.innerHTML = '';

    // Podium order: 2nd left, 1st centre, 3rd right
    const podiumOrder = [products[1], products[0], products[2]];

    const giftWrapLabel   = document.querySelector('[data-gift-wrap-label]')?.dataset.giftWrapLabel
      || 'Add gift wrapping & custom gift card + $9.95';
    const reviewCount = window.STARDATE_REVIEW_COUNT || '301';

    const productData = await Promise.all(podiumOrder.map(p => fetchProductByType(p.type, dateTag, zodiac)));

    /*
  PRODUCT CARDS — JS CHANGE
*/
podiumOrder.forEach(function(p, i) {
      var data    = productData[i];
      var slot    = document.createElement('div');
      slot.className = 'product-card-slot';

      var imgUrl    = data && data.image ? data.image : '';
      var title     = data && data.title ? data.title : p.type;
      var price     = data && data.price ? '$' + (parseInt(data.price) / 100).toFixed(2) : '';
      var variantId = data && data.variantId ? data.variantId : '';
      var isPrimary = p.isMain;

      var cardClass = isPrimary ? 'product-card-new product-card-new--primary' : 'product-card-new product-card-new--secondary';
      var atcClass  = isPrimary ? 'product-card-new__atc product-card-new__atc--primary' : 'product-card-new__atc product-card-new__atc--secondary';
var atcText = 'Add →';
      var sub       = p.sub || '';

      var productLink = data && data.url ? data.url : '#';

      slot.innerHTML =
        '<div class="' + cardClass + '">' +
          (isPrimary ? '<span class="product-card-new__badge">★ Highly Recommended</span>' : '') +
          (imgUrl
            ? '<a href="' + productLink + '" target="_blank" rel="noopener noreferrer" class="product-card-new__img-link" style="display:block;line-height:0;text-decoration:none;cursor:pointer;" aria-label="View ' + title + ' product page"><img src="' + imgUrl + '" alt="' + title + '" class="product-card-new__img" loading="lazy"></a>'
            : '<div class="product-card-new__img"></div>') +
          '<div class="product-card-new__body">' +
            '<div class="product-card-new__title"><a href="' + productLink + '" target="_blank" rel="noopener noreferrer" style="color:inherit;text-decoration:none;cursor:pointer;">' + title + '</a></div>' +
            '<div class="product-card-new__sub">' + sub + '</div>' +
            (isPrimary ?
              '<div class="product-card-new__stars">★★★★★</div>' +
              '<div class="product-card-new__reviews">' + reviewCount + ' Reviews</div>'
            : '') +
            '<div class="product-card-new__footer">' +
              '<span class="product-card-new__price">' + price + '</span>' +
              '<button class="' + atcClass + '"' +
                ' data-variant="' + variantId + '"' +
                ' data-recipient="' + recipName + '"' +
                ' data-birthday="' + bdayStr + '"' +
                ' data-zodiac="' + zodiac + '"' +
                ' data-fragrance="' + fragrance + '">' +
                atcText +
              '</button>' +
            '</div>' +
          '</div>' +
        '</div>';

      podium.appendChild(slot);
    });


    // Main footer CTA mirrors centre card
    const mainData = productData[1]; // index 1 = best match (centre)
    // Update testimonial to match actual best match product type
    const bestMatchTag = products[0].type;
    const bestTestimonial = CONFIG.testimonials[bestMatchTag] || {};
    const testimonialEl2  = qs('#product-proof-testimonial');
    if (testimonialEl2 && bestTestimonial.quote) {
      testimonialEl2.innerHTML =
        '"' + bestTestimonial.quote + '"' +
        (bestTestimonial.author
          ? '<span class="product-proof__testimonial-author"> — ' + bestTestimonial.author + '</span>'
          : '');
    }
    const mainBtn  = qs('#product-results-main-atc');
    const mainPrice = mainData?.price ? '$' + (parseInt(mainData.price) / 100).toFixed(2) : '';
    mainBtn.textContent = (mainPrice ? mainPrice + ' — ' : '') +
      'CREATE ' + (recipName ? recipName.toUpperCase() + "'S" : '') + ' GIFT';
    mainBtn.dataset.variant   = mainData?.variantId || '';
    mainBtn.dataset.recipient = recipName;
    mainBtn.dataset.birthday  = bdayStr;
    mainBtn.dataset.zodiac    = zodiac;
    mainBtn.dataset.fragrance = fragrance;

    // Click handlers
    podium.addEventListener('click', e => {
      const btn = e.target.closest('.product-card-new__atc');
      if (btn) handleProductAtc(btn);
    });

    mainBtn.addEventListener('click', () => handleProductAtc(mainBtn));

    qs('#retake-quiz-btn')?.addEventListener('click', () => showScreen('hero'));

    initProductGallery(podiumOrder, productData, recipName, bdayStr, zodiac, fragrance);

    // Klaviyo: Scent Quiz Product Results Viewed — Track B Email 1 trigger event
    // Carries full fragrance selection data + product images so email is self-contained
    try {
      if (state.answers.email && window._learnq) {
        var kSel = state.results.selectedFragrance;
        var kSelHandle = kSel ? (CONFIG.fragranceHandles || {})[kSel.sign] : null;
        var kSelMeta = kSelHandle && window.STARDATE_FRAGRANCES
          ? window.STARDATE_FRAGRANCES[kSelHandle] : null;
        var kSelNotes = kSelMeta
          ? [kSelMeta.topNotes, kSelMeta.heartNotes, kSelMeta.baseNotes]
              .filter(Boolean).join(' · ')
          : '';

        var kGetFragImage = function(idx) {
          var kTop3 = state.results.top3Fragrances;
          if (!kTop3[idx]) return '';
          var kH = (CONFIG.fragranceHandles || {})[kTop3[idx].sign];
          var kM = kH && window.STARDATE_FRAGRANCES
            ? window.STARDATE_FRAGRANCES[kH] : null;
          return kM && kM.image ? kM.image : '';
        };

        var kGetFragLifestyleImage = function(idx) {
          var kTop3 = state.results.top3Fragrances;
          if (!kTop3[idx]) return '';
          var kH = (CONFIG.fragranceHandles || {})[kTop3[idx].sign];
          var kM = kH && window.STARDATE_FRAGRANCES
            ? window.STARDATE_FRAGRANCES[kH] : null;
          return kM && kM.imageLifestyle ? kM.imageLifestyle : '';
        };

        window._learnq.push(['track', 'Scent Quiz Product Results Viewed', {
          'Quiz Session ID': state.results.quizSessionId || '',
          'Purchaser Name': state.answers.purchaserName || '',
          'Recipient Name': recipName,
          'Recipient Birthday Day': state.answers.birthday.day || '',
          'Recipient Birthday Month': state.answers.birthday.month || '',
          'Zodiac Sign': zodiac,
          'Occasion': state.answers.occasion || '',
          'Zodiac Icon URL': window.STARDATE_ZODIAC_ICONS && zodiac
            ? (window.STARDATE_ZODIAC_ICONS[zodiac] || '') : '',

          // Selected fragrance — full data for Track B Email 1
          'Selected Fragrance': kSel ? kSel.fragrance.name : fragrance,
          'Selected Fragrance Sign': kSel ? kSel.sign : '',
          'Selected Fragrance Image URL': kSelMeta && kSelMeta.image ? kSelMeta.image : '',
          'Selected Fragrance Lifestyle Image URL': kSelMeta && kSelMeta.imageLifestyle ? kSelMeta.imageLifestyle : '',
          'Selected Fragrance Description': kSelMeta && kSelMeta.description ? kSelMeta.description : '',
          'Selected Fragrance Primary Scent Profile': kSelMeta && kSelMeta.primaryScentProfile ? kSelMeta.primaryScentProfile : '',
          'Selected Fragrance Notes': kSelNotes,

          // All three fragrance names and images for context
          'Top Fragrance': state.results.top3Fragrances[0] ? state.results.top3Fragrances[0].fragrance.name : '',
          'Top Fragrance Image URL': kGetFragImage(0),
          'Top Fragrance Lifestyle Image URL': kGetFragLifestyleImage(0),
          'Second Fragrance': state.results.top3Fragrances[1] ? state.results.top3Fragrances[1].fragrance.name : '',
          'Second Fragrance Image URL': kGetFragImage(1),
          'Second Fragrance Lifestyle Image URL': kGetFragLifestyleImage(1),
          'Third Fragrance': state.results.top3Fragrances[2] ? state.results.top3Fragrances[2].fragrance.name : '',
          'Third Fragrance Image URL': kGetFragImage(2),
          'Third Fragrance Lifestyle Image URL': kGetFragLifestyleImage(2),

          // Candle (index 1 = best match / centre card)
          'Candle Title': productData[1] && productData[1].title ? productData[1].title : '',
          'Candle Image URL': productData[1] && productData[1].image ? productData[1].image : '',
          'Candle Price': productData[1] && productData[1].price
            ? '$' + (parseInt(productData[1].price) / 100).toFixed(2) : '',
          'Candle URL': productData[1] && productData[1].url ? productData[1].url : 'https://stardateco.com.au',

          // Diffuser (index 0 = left card)
          'Diffuser Title': productData[0] && productData[0].title ? productData[0].title : '',
          'Diffuser Image URL': productData[0] && productData[0].image ? productData[0].image : '',
          'Diffuser Price': productData[0] && productData[0].price
            ? '$' + (parseInt(productData[0].price) / 100).toFixed(2) : '',
          'Diffuser URL': productData[0] && productData[0].url ? productData[0].url : 'https://stardateco.com.au',

          // Gift card (index 2 = right card)
          'Gift Card Title': productData[2] && productData[2].title ? productData[2].title : '',
          'Gift Card Image URL': productData[2] && productData[2].image ? productData[2].image : '',
          'Gift Card URL': 'https://stardateco.com.au/products/stardate-gift-card'
        }]);
      }
    } catch(e) {
      console.error('Klaviyo Product Results event error:', e);
    }
  }

  // ----------------------------------------------------------
  // FETCH PRODUCT BY TYPE
  // ----------------------------------------------------------
  async function fetchProductByType(productTypeTag, dateTag, zodiac) {
    try {
      var product = null;

      // Build lookup key from state directly — month name lowercase + day integer
      var day   = parseInt(state.answers.birthday.day, 10);
      var month = state.answers.birthday.month; // numeric e.g. "10"
      var monthNames = ['january','february','march','april','may','june',
                        'july','august','september','october','november','december'];
      var monthName = monthNames[parseInt(month, 10) - 1];
      var lookupKey = monthName + '-' + day; // e.g. "october-7"
      console.log('fetchProductByType called:', productTypeTag, 'lookupKey will be:', 
  ['january','february','march','april','may','june','july','august','september','october','november','december'][parseInt(state.answers.birthday.month, 10) - 1] 
  + '-' + parseInt(state.answers.birthday.day, 10));

      if (productTypeTag === CONFIG.productTypeTags.birthdayCandle) {
        var entry = window.STARDATE_PRODUCTS && window.STARDATE_PRODUCTS.candles
          ? window.STARDATE_PRODUCTS.candles[lookupKey] : null;
        if (entry) return entry;

      } else if (productTypeTag === CONFIG.productTypeTags.birthdayDiffuser) {
        var entry = window.STARDATE_PRODUCTS && window.STARDATE_PRODUCTS.diffusers
          ? window.STARDATE_PRODUCTS.diffusers[lookupKey] : null;
        if (entry) return entry;

      } else if (productTypeTag === CONFIG.productTypeTags.giftCard) {
        // Gift card: fetch by handle directly
        var res = await fetch('/products/stardate-gift-card.json');
        if (res.ok) {
          var data = await res.json();
          product = data.product;
          // Find the $100 variant
          if (product && product.variants) {
            var hundredVariant = product.variants.find(function(v) {
              return v.price === '100.00' || v.price === '100';
            });
            if (hundredVariant) {
              return {
                title:     product.title,
                image:     product.images && product.images[0] ? product.images[0].src : '',
                price:     hundredVariant.price.replace('.', ''),
                variantId: hundredVariant.id,
                url:       '/products/stardate-gift-card'
              };
            }
          }
        }
      }

      if (!product) return null;

      return {
        title:     product.title,
        image:     product.images && product.images[0] ? product.images[0].src : '',
        price:     product.variants && product.variants[0] ? product.variants[0].price.replace('.', '') : '',
        variantId: product.variants && product.variants[0] ? product.variants[0].id : ''
      };
    } catch (e) {
      console.error('Product fetch error:', e);
      return null;
    }
  }

  // ----------------------------------------------------------
  // HANDLE PRODUCT ATC
  // ----------------------------------------------------------
  async function handleProductAtc(btn) {
    btn.disabled    = true;
    var origText  = btn.textContent;
    btn.textContent = 'Adding…';

    var variantId  = btn.dataset.variant;
    var recipName  = btn.dataset.recipient;
    var birthday   = btn.dataset.birthday;
    var zodiac     = btn.dataset.zodiac;
    var fragrance  = btn.dataset.fragrance;

    var items = [{
      id:       parseInt(variantId, 10),
      quantity: 1,
      properties: {
        'Recipient Name': recipName,
        'Birthday':       birthday,
        'Zodiac Sign':    zodiac,
        'Fragrance':      fragrance,
        '_quiz_source':   'scent-quiz',
        '_quiz_session':  state.results.quizSessionId || ''
      }
    }];

    try {
      var res = await fetch('/cart/add.js', {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body:    JSON.stringify({ items: items })
      });
      if (!res.ok) throw new Error('Cart error');

      btn.textContent = '✓ Added!';
      if (typeof gtag === 'function') {
  gtag('event', 'quiz_add_to_cart', {
    'quiz_product': btn.dataset.fragrance || '',
    'quiz_recipient': btn.dataset.recipient || '',
    'quiz_zodiac': btn.dataset.zodiac || ''
  });
}
      btn.classList.add('quiz-btn--success');

      // Show gift wrap upsell prompt
      showGiftWrapPrompt();

    } catch (err) {
      console.error('ATC error:', err);
      btn.textContent = origText;
      btn.disabled    = false;
    }
  }

  function showGiftWrapPrompt() {
    var prompt = qs('#gift-wrap-upsell');
    if (!prompt) {
      setTimeout(function() { window.location.href = '/cart'; }, 800);
      return;
    }

    prompt.style.display = 'block';

    // "Add Gift Wrap" button — adds wrap then goes to cart
    var yesBtn = qs('#gift-wrap-yes');
    if (yesBtn) {
      yesBtn.onclick = async function() {
        yesBtn.disabled = true;
        yesBtn.textContent = 'Adding…';
        await addGiftWrapToCart();
        yesBtn.textContent = '✓ Added!';
        setTimeout(function() { window.location.href = '/cart'; }, 600);
      };
    }

    // "No thanks" button — goes straight to cart
    var skipBtn = qs('#gift-wrap-skip');
    if (skipBtn) {
      skipBtn.onclick = function() {
        window.location.href = '/cart';
      };
    }

    // "X" close button — dismisses modal, stays on page
    var closeBtn = qs('#gift-wrap-close');
    if (closeBtn) {
      closeBtn.onclick = function() {
        prompt.style.display = 'none';
      };
    }

    // Click backdrop to close
    prompt.onclick = function(e) {
      if (e.target === prompt) {
        prompt.style.display = 'none';
      }
    };
  }

  async function addGiftWrapToCart() {
    try {
      var res = await fetch('/products/gift-wrapping.json');
      if (!res.ok) throw new Error('Gift wrap fetch failed');
      var data = await res.json();
      var wrapVariantId = data.product && data.product.variants && data.product.variants[0]
        ? data.product.variants[0].id : null;
      if (wrapVariantId) {
        var addRes = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: wrapVariantId, quantity: 1 }] })
        });
        if (!addRes.ok) throw new Error('Gift wrap add failed');
      }
    } catch (err) {
      console.error('Gift wrap error:', err);
    }
  }


  // ----------------------------------------------------------
  // LOADING ANIMATION
  // ----------------------------------------------------------
  function runLoading(onDone) {
    // Set recipient name
    var nameEl = qs('#loading-recipient-name');
    if (nameEl) {
      var recipName = state.answers.name || '';
      nameEl.textContent = recipName ? recipName + '\u2019s' : 'your';
    }

    // Inject zodiac SVGs
    var zodiac = state.results.zodiac; // e.g. "Cancer"
    var borderUrl = window.STARDATE_ZODIAC_BORDERS && zodiac
      ? window.STARDATE_ZODIAC_BORDERS[zodiac] : null;
    var iconUrl = window.STARDATE_ZODIAC_ICONS && zodiac
      ? window.STARDATE_ZODIAC_ICONS[zodiac] : null;
    var borderContainer = qs('#loading-zodiac-border');
    var iconContainer   = qs('#loading-zodiac-icon');

    if (borderUrl && borderContainer) {
      fetch(borderUrl)
        .then(function(r) { return r.text(); })
        .then(function(svgText) {
          borderContainer.innerHTML = svgText;
          var svg = borderContainer.querySelector('svg');
          if (svg) {
            svg.style.width  = '100%';
            svg.style.height = '100%';
          }
        })
        .catch(function() {
          console.warn('Stardate: zodiac border SVG failed to load for', zodiac);
        });
    }

    if (iconUrl && iconContainer) {
      fetch(iconUrl)
        .then(function(r) { return r.text(); })
        .then(function(svgText) {
          iconContainer.innerHTML = svgText;
          var svg = iconContainer.querySelector('svg');
          if (svg) {
            svg.style.width  = '100%';
            svg.style.height = '100%';
          }
        })
        .catch(function() {
          console.warn('Stardate: zodiac icon SVG failed to load for', zodiac);
        });
    }

    // Animate ZODIAC pill to done after 1.8s
    setTimeout(function() {
      var pill = qs('#loading-pill-zodiac');
      if (pill) {
        pill.textContent = '✓ ZODIAC';
        pill.classList.remove('loading-pill--pending');
        pill.classList.add('loading-pill--done');
      }
    }, 1800);

    setTimeout(onDone, 2800);
  }

  // ----------------------------------------------------------
  // BACK NAVIGATION
  // ----------------------------------------------------------
  function goBack() {
    const map = {
      'who-for':           'hero',
      'occasion':          'who-for',
      'personality':       'occasion',
      'vibe':              'personality',
      'scent-family':      'vibe',
      'birthday':          'scent-family',
      'name':              'birthday',
      'email':             'name',
      'fragrance-results': 'email'
    };
    const prev = map[SCREENS[state.currentScreen]];
    if (prev) showScreen(prev);
  }

  // ----------------------------------------------------------
  // INIT
  // ----------------------------------------------------------
  function init() {
    if (!qs('#stardate-quiz')) return;

    // Back buttons
    qsa('.quiz-back-btn').forEach(b => b.addEventListener('click', goBack));

    // Hero
    qs('#quiz-start-btn')?.addEventListener('click', () => showScreen('who-for'));

    // Card screens — auto-advance
    initCardGrid(qs('[data-screen="who-for"]'),      'whoFor',      () => showScreen('occasion'));
    initCardGrid(qs('[data-screen="occasion"]'),     'occasion',    () => showScreen('personality'));
    initCardGrid(qs('[data-screen="personality"]'),  'personality', () => showScreen('vibe'));
    initCardGrid(qs('[data-screen="vibe"]'),         'vibe',        () => showScreen('scent-family'));
    initCardGrid(qs('[data-screen="scent-family"]'), 'scentFamily', () => showScreen('birthday'));

    // Birthday
    const bdayScreen = qs('[data-screen="birthday"]');
    if (bdayScreen) {
      const dayEl   = qs('#bday-day',   bdayScreen);
      const monthEl = qs('#bday-month', bdayScreen);
      const yearEl  = qs('#bday-year',  bdayScreen);
      dayEl.addEventListener('change', function() {
  showZodiacPanel(dayEl.value, monthEl.value);
});
monthEl.addEventListener('change', function() {
  showZodiacPanel(dayEl.value, monthEl.value);
});

      for (let d = 1; d <= 31; d++) {
        const o = document.createElement('option');
        o.value = d; o.textContent = d;
        dayEl.appendChild(o);
      }
      ['January','February','March','April','May','June',
       'July','August','September','October','November','December']
        .forEach((m, i) => {
          const o = document.createElement('option');
          o.value = i + 1; o.textContent = m;
          monthEl.appendChild(o);
        });

      const blank = document.createElement('option');
      blank.value = ''; blank.textContent = 'YYYY';
      yearEl.appendChild(blank);
      const yr = new Date().getFullYear();
      for (let y = yr; y >= yr - 100; y--) {
        const o = document.createElement('option');
        o.value = y; o.textContent = y;
        yearEl.appendChild(o);
      }

      qs('#bday-continue', bdayScreen).addEventListener('click', () => {
        const d = dayEl.value, m = monthEl.value;
        if (!d || !m) {
          qs('#bday-error', bdayScreen).classList.remove('quiz-hidden');
          return;
        }
        qs('#bday-error', bdayScreen).classList.add('quiz-hidden');
        state.answers.birthday      = { day: d, month: m, year: yearEl.value || null };
        state.results.zodiac        = getZodiac(d, m);
        state.results.dateTag       = buildDateTag(d, m);
        showScreen('name');
      });
    }

    // Name
    const nameScreen = qs('[data-screen="name"]');
    if (nameScreen) {
      const inp = qs('#recipient-name', nameScreen);
      qs('#name-continue', nameScreen).addEventListener('click', () => {
        state.answers.name = inp.value.trim();
        showScreen('email');
      });
      inp.addEventListener('keydown', e => {
        if (e.key === 'Enter') qs('#name-continue', nameScreen).click();
      });
    }

    // Email
    const emailScreen = qs('[data-screen="email"]');
    if (emailScreen) {
      const proceed = () => {
        state.answers.email         = (qs('#purchaser-email', emailScreen)?.value || '').trim();
        state.answers.purchaserName = (qs('#purchaser-name',  emailScreen)?.value || '').trim();

        // Generate session ID immediately — shared across all events
        var quizSessionId = 'quiz_' + Date.now() + '_' + Math.random().toString(36).substr(2, 6);
        state.results.quizSessionId = quizSessionId;

        var email = state.answers.email;
        if (email && window._learnq) {
          // Identify the profile immediately — creates/updates the profile before they reach results
          // We do NOT fire 'Scent Quiz Completed' here because fragrance data isn't computed yet.
          // Firing it now and then "patching" later doesn't work — Klaviyo treats them as
          // separate events, and the flow triggers on the first (data-empty) one.
          // The full 'Scent Quiz Completed' event is fired inside runLoading() below, once
          // computeScores() has resolved the fragrance data.
          window._learnq.push(['identify', {
            '$email': email,
            '$first_name': state.answers.purchaserName || '',
            'Quiz - Latest Recipient': state.answers.name || '',
            'Quiz - Latest Zodiac': state.results.zodiac || '',
            'Quiz - Latest Session ID': quizSessionId,
            'Quiz - Completed': true,
            'Quiz - Completed Date': new Date().toISOString(),
            'Quiz - Completion Count': (window._stardateQuizCount = (window._stardateQuizCount || 0) + 1)
          }]);
        }

        // Show the loading screen FIRST so the user sees the zodiac animation
        // while scoring runs and Klaviyo events fire.
        showScreen('loading');

runLoading(() => {
          state.results.top3Fragrances = computeScores();
          buildFragranceResults();
          showScreen('fragrance-results');

          // Fire Scent Quiz Fragrance Results Viewed — fragrance data now resolved
          if (state.answers.email && window._learnq) {
            var top3 = state.results.top3Fragrances;

            var getFragData = function(idx, field) {
              if (!top3[idx]) return '';
              var handle = (CONFIG.fragranceHandles || {})[top3[idx].sign];
              var metaFrag = handle && window.STARDATE_FRAGRANCES
                ? window.STARDATE_FRAGRANCES[handle] : null;
              if (!metaFrag) return '';
              if (field === 'image')               return metaFrag.image || '';
              if (field === 'imageLifestyle')      return metaFrag.imageLifestyle || '';
              if (field === 'description')         return metaFrag.description || '';
              if (field === 'primaryScentProfile') return metaFrag.primaryScentProfile || '';
              if (field === 'notes') {
                return [metaFrag.topNotes, metaFrag.heartNotes, metaFrag.baseNotes]
                  .filter(Boolean).join(' · ');
              }
              return '';
            };

            // Build shared fragrance payload — used by both events below
            var fragrancePayload = {
              // Top match
              'Top Fragrance': top3[0] ? top3[0].fragrance.name : '',
              'Top Fragrance Image URL': getFragData(0, 'image'),
              'Top Fragrance Lifestyle Image URL': getFragData(0, 'imageLifestyle'),
              'Top Fragrance Description': getFragData(0, 'description'),
              'Top Fragrance Primary Scent Profile': getFragData(0, 'primaryScentProfile'),
              'Top Fragrance Notes': getFragData(0, 'notes'),

              // Second match
              'Second Fragrance': top3[1] ? top3[1].fragrance.name : '',
              'Second Fragrance Image URL': getFragData(1, 'image'),
              'Second Fragrance Lifestyle Image URL': getFragData(1, 'imageLifestyle'),
              'Second Fragrance Description': getFragData(1, 'description'),
              'Second Fragrance Primary Scent Profile': getFragData(1, 'primaryScentProfile'),
              'Second Fragrance Notes': getFragData(1, 'notes'),

              // Third match
              'Third Fragrance': top3[2] ? top3[2].fragrance.name : '',
              'Third Fragrance Image URL': getFragData(2, 'image'),
              'Third Fragrance Lifestyle Image URL': getFragData(2, 'imageLifestyle'),
              'Third Fragrance Description': getFragData(2, 'description'),
              'Third Fragrance Primary Scent Profile': getFragData(2, 'primaryScentProfile'),
              'Third Fragrance Notes': getFragData(2, 'notes')
            };

            // Fire Scent Quiz Fragrance Results Viewed
            window._learnq.push(['track', 'Scent Quiz Fragrance Results Viewed', Object.assign({}, {
              'Quiz Session ID': state.results.quizSessionId || '',
              'Purchaser Name': state.answers.purchaserName || '',
              'Recipient Name': state.answers.name || '',
              'Recipient Birthday Day': state.answers.birthday.day || '',
              'Recipient Birthday Month': state.answers.birthday.month || '',
              'Zodiac Sign': state.results.zodiac || '',
              'Occasion': state.answers.occasion || ''
            }, fragrancePayload)]);

            // Also patch Scent Quiz Completed with fragrance data
            // This makes Track A emails fully self-contained from the trigger event
            window._learnq.push(['track', 'Scent Quiz Completed', Object.assign({}, {
              'Quiz Session ID': state.results.quizSessionId || '',
              'Purchaser Name': state.answers.purchaserName || '',
              'Who For': state.answers.whoFor || '',
              'Occasion': state.answers.occasion || '',
              'Personality': state.answers.personality || '',
              'Vibe': state.answers.vibe || '',
              'Scent Family': state.answers.scentFamily || '',
              'Recipient Name': state.answers.name || '',
              'Recipient Birthday Day': state.answers.birthday.day || '',
              'Recipient Birthday Month': state.answers.birthday.month || '',
              'Zodiac Sign': state.results.zodiac || ''
            }, fragrancePayload)]);

            // Update profile with latest fragrance name now that scoring is complete
            window._learnq.push(['identify', {
              '$email': state.answers.email,
              'Quiz - Latest Fragrance': top3[0] ? top3[0].fragrance.name : ''
            }]);
          }
        });
      };
      qs('#email-submit', emailScreen)?.addEventListener('click', proceed);
      qs('#email-skip',   emailScreen)?.addEventListener('click', proceed);
    }

    // Fragrance results → product results
    const pairAction = () => {
      showScreen('product-results');
      buildProductResults();
    };
    qs('#pair-with-gift-btn')?.addEventListener('click', pairAction);
    qs('#pair-with-gift-btn-mobile')?.addEventListener('click', pairAction);

    // Inline gift wrap button
    var inlineWrapBtn = qs('#gift-wrap-inline-btn');
    if (inlineWrapBtn) {
      inlineWrapBtn.addEventListener('click', async function() {
        inlineWrapBtn.disabled = true;
        inlineWrapBtn.textContent = 'Adding…';
        await addGiftWrapToCart();
        inlineWrapBtn.textContent = '✓ Added';
        inlineWrapBtn.style.background = '#2a6a2a';
        inlineWrapBtn.style.color = '#fff';
        inlineWrapBtn.style.borderColor = '#2a6a2a';
      });
    }

    // Start
    showScreen('hero');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();